<template>
  <form @submit.prevent>
    <div class="form-group">
      <input v-model="teamName" placeholder="Enter team name" />
    </div>

    <div class="text-center flex justify-center">
      <button
        class="button-gemnote button-gemnote--small "
        :class="{ 'button-gemnote--disabled': addingNewTeam }"
        :disabled="addingNewTeam"
        @click="addTeam"
      >
        <span>Add</span>
      </button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AddTeamForm',
  data: function() {
    return {
      teamName: ''
    }
  },
  computed: {
    ...mapState({
      addingNewTeam: state => state.subTeams.addingNewTeam
    })
  },
  methods: {
    addTeam() {
      this.$store.dispatch('subTeams/addSubTeam', this.teamName)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

form {
  width: 80%;
  height: 100%;
  margin: 1rem auto;
}

.button-gemnote {
  width: auto;
  font-weight: bold;
  margin-top: 2rem;
  white-space: unset;
  padding: 0 3rem !important;
  font-size: 1rem;
  background: $pebble;
  color: $linen;
  border: 1px solid $onyx;

  &:hover {
    background: $main-white;
    opacity: 0.8;
  }
}

@media (max-width: 1000px) {
  form {
    width: 100%;
  }
}

::placeholder {
  color: $pebble;
}
</style>
